// extracted by mini-css-extract-plugin
export default {"Dashboard":"style_Dashboard__4ZQ8a","MiddleRow":"style_MiddleRow__Aabyo","TitleRow":"style_TitleRow__xW0l2","SettingsRow":"style_SettingsRow__fmQqe"};